import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import Cancel from '@material-ui/icons/Cancel'
import Moment from 'react-moment'

import Dashboard from './Dashboard'
import UMapExplorerOnBoarding from './UMapExplorerOnBoarding'
import './UMapExplorerComponent.scss'
import Spinner from '../Spinner'
import NotFound from '../NotFound'

export default class UMapExplorerComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    homepage: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    fetchuMapTopicPlan: PropTypes.func.isRequired,
    fetchuMapGenreDemo: PropTypes.func.isRequired,
    setUMapSelectedTopic: PropTypes.func.isRequired,
    genreDemoSummary: PropTypes.object,
    plan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      currentPage: PropTypes.number.isRequired,
      endOfResult: PropTypes.bool.isRequired,
      planFilters: PropTypes.object.isRequired,
      details: PropTypes.object
    }).isRequired,
    selectedTopic: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      hideShortcutBanner: false
    }
  }

  componentDidMount () {
    document.body.classList.add('discoverBody')
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }
    const name = 'Discover Tour'
    return (
      <UMapExplorerOnBoarding
        name={name}
        run={true}
      />
    )
  }

  render () {
    if (!this.props.homepage.details && !this.props.shortcut) {
      return (<Spinner />)
    }

    if (this.props.homepage.error || (!this.props.homepage.isFetching && this.props.homepage.details && this.props.homepage.details.discover_entities && this.props.homepage.details.discover_entities.length === 0)) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }

    return (
      <div className="rightSide">
        <Container fluid={true}>
          {this._renderShortcut()}
          {this._renderOnboarding()}
          <Row className="header umap discover">
            <Col>
              <ul className="hFirstRow">
                <li className="discThumb">
                  <img alt="" src="/static/images/compass.png" className="imgThumb" />
                </li>
                <li>
                  <h2 className="title mb-0">Discover</h2>
                </li>
              </ul>
            </Col>
          </Row>
          <Row>
            <Col>
              <Dashboard
                fetchuMapTopicPlan={this.props.fetchuMapTopicPlan}
                fetchuMapGenreDemo={this.props.fetchuMapGenreDemo}
                setUMapSelectedTopic={this.props.setUMapSelectedTopic}
                plan={this.props.plan}
                selectedTopic={this.props.selectedTopic}
                genreDemoSummary={this.props.genreDemoSummary}
              />
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}